/**
 * @module core/config
 *
 * URLs do ecossistema lidas via Vite (import.meta.env). Os valores vêm de:
 *   - dev: .env.development (API_URL=..., TREX_URL=..., etc)
 *   - hml: .env.hml          (carregado com --mode hml)
 *   - prd: .env.production
 *
 * O Vite injeta essas vars em build-time. Pra que vars sem prefixo
 * VITE_ sejam lidas, `envPrefix: ''` está setado em vite.config.js.
 */

const API_URL = import.meta.env.API_URL || '';
const HOST_URL = import.meta.env.ESQUILO_URL || '';
const TREX_URL = import.meta.env.TREX_URL || '';
const ENV = import.meta.env.MODE || 'development';
const PARTICIPE_URL = import.meta.env.PARTICIPE_URL || '';
const VAQUINHA_URL = import.meta.env.VAQUINHA_URL || '';

export { API_URL, HOST_URL, TREX_URL, ENV, PARTICIPE_URL, VAQUINHA_URL };
